import { render, staticRenderFns } from "./ClientCart.vue?vue&type=template&id=ffc9e180&scoped=true&"
import script from "./ClientCart.vue?vue&type=script&lang=js&"
export * from "./ClientCart.vue?vue&type=script&lang=js&"
import style0 from "./ClientCart.vue?vue&type=style&index=0&id=ffc9e180&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc9e180",
  null
  
)

export default component.exports